(() => {
  const path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
  const queryString = window.location.search || "";
  const missing = {
    "/catalog": "/collections/all",
    "/shop": "/collections/all",
    "/products": "/collections/all",
    "/contact": "/#contact",
    "/pages/contact": "/#contact",
    "/pages/lab-tests": "/#price-list",
    "/pages/shipping": "/",
    "/pages/about": "/"
  };
  if (missing[path]) {
    window.location.replace(missing[path] + queryString);
    return;
  }

  const moneyFormat = window.ScotiaTheme?.moneyFormat || "${{amount}}";
  const waNumber = String(window.ScotiaTheme?.whatsapp || "447423098528").replace(/\D/g, "");
  const LOCAL_KEY = "scotia-local-cart";
  const POPUP_KEY = "scotia-welcome";

  const formatMoney = (cents) => {
    const amount = Number(cents) || 0;
    const value = (amount / 100).toFixed(2);
    const plain = String(moneyFormat).replace(/<[^>]+>/g, "");
    const formatted = plain
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
    if (!formatted || formatted.includes("{{")) return `£${value}`;
    return formatted;
  };

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const waLink = (text) =>
    `https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`;

  let lastShopifyCart = { items: [] };

  const isMobileOrder = () =>
    window.matchMedia("(pointer: coarse)").matches ||
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || "");

  const goToWhatsApp = (url) => {
    if (!url) return;
    if (isMobileOrder()) {
      window.location.href = url;
      return;
    }
    const win = window.open(url, "_blank");
    if (!win) window.location.href = url;
  };

  const syncWhatsAppCheckoutLinks = (cart) => {
    const url = waLink(buildOrderMessage(cart || lastShopifyCart));
    qsa("[data-whatsapp-checkout]").forEach((el) => {
      if (el.tagName === "A") el.setAttribute("href", url);
    });
  };

  const priceToCents = (value, cents) => {
    const fromAttr = Number(cents);
    if (Number.isFinite(fromAttr) && fromAttr > 0) return fromAttr;
    const n = parseFloat(String(value || "").replace(/[^0-9.]/g, ""));
    return Number.isFinite(n) ? Math.round(n * 100) : 0;
  };

  const itemUnitCents = (item) => Number(item.cents) || priceToCents(item.price);

  const readLocal = () => {
    try {
      return JSON.parse(localStorage.getItem(LOCAL_KEY) || "[]").map((item) => ({
        ...item,
        cents: itemUnitCents(item),
      }));
    } catch {
      return [];
    }
  };

  const writeLocal = (items) => localStorage.setItem(LOCAL_KEY, JSON.stringify(items));

  const localCount = () => readLocal().reduce((sum, item) => sum + Number(item.quantity || 1), 0);

  const localSubtotalCents = () =>
    readLocal().reduce((sum, item) => sum + itemUnitCents(item) * Number(item.quantity || 1), 0);

  const setCartCount = (shopifyCount) => {
    const count = Number(shopifyCount || 0) + localCount();
    qsa("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.toggleAttribute("hidden", count === 0);
    });
  };

  const openCart = () => {
    document.body.classList.add("cart-open");
    qs("[data-cart-drawer]")?.setAttribute("aria-hidden", "false");
    qs("[data-cart-close]")?.focus();
  };

  const closeCart = () => {
    document.body.classList.remove("cart-open");
    qs("[data-cart-drawer]")?.setAttribute("aria-hidden", "true");
  };

  const closeNav = () => document.body.classList.remove("nav-open");
  const closeSearch = () => {
    document.body.classList.remove("search-open");
    qsa("[data-search-panel]").forEach((el) => el.setAttribute("hidden", ""));
  };

  const addLocalItem = (item) => {
    const items = readLocal();
    const cents = itemUnitCents(item);
    const existing = items.find((row) => row.id === item.id);
    if (existing) {
      existing.quantity += 1;
      existing.cents = cents;
      existing.price = item.price || existing.price;
      existing.image = item.image || existing.image;
    } else {
      items.push({ ...item, quantity: 1, cents });
    }
    writeLocal(items);
  };

  const changeLocalQty = (id, qty) => {
    let items = readLocal();
    if (Number(qty) <= 0) items = items.filter((row) => row.id !== id);
    else {
      items = items.map((row) => (row.id === id ? { ...row, quantity: Number(qty) } : row));
    }
    writeLocal(items);
  };

  const formatPounds = (cents) => {
    const amount = Number(cents) || 0;
    if (amount % 100 === 0) return `£${amount / 100}`;
    return `£${(amount / 100).toFixed(2)}`;
  };

  const buildOrderMessage = (shopifyCart) => {
    const lines = [];
    let totalCents = 0;
    (shopifyCart?.items || []).forEach((item) => {
      const qty = Number(item.quantity || 1);
      const unit = Number(item.final_price || item.price || 0);
      const line = Number(item.final_line_price || unit * qty);
      totalCents += line;
      lines.push(`• ${qty}x ${item.product_title} (${formatPounds(unit)})`);
    });
    readLocal().forEach((item) => {
      const qty = Number(item.quantity || 1);
      const unit = itemUnitCents(item);
      totalCents += unit * qty;
      const priceLabel = unit ? formatPounds(unit) : item.price;
      lines.push(`• ${qty}x ${item.title}${priceLabel ? ` (${priceLabel})` : ""}`);
    });
    if (!lines.length) {
      return "Hi Scotia Peptides, I would like to order.";
    }
    return [
      "Hi Scotia Peptides, I would like to order:",
      "",
      ...lines,
      "",
      `Total: ${formatPounds(totalCents)}`
    ].join("\n");
  };

  const openWhatsAppOrder = () => {
    goToWhatsApp(waLink(buildOrderMessage(lastShopifyCart)));
  };

  const renderLocalRows = () =>
    readLocal()
      .map((item) => {
        const image = item.image
          ? `<img src="${item.image}" alt="${item.title.replace(/"/g, "&quot;")}" class="h-20 w-20 rounded-lg object-contain bg-white" width="80" height="80">`
          : `<div class="h-20 w-20 rounded-lg bg-scotia-mist"></div>`;
        return `
          <div class="flex gap-3 border-b border-gray-100 py-4" data-local-key="${item.id}">
            ${image}
            <div class="min-w-0 flex-1">
              <p class="font-display text-sm font-semibold text-scotia">${item.title}</p>
              <div class="mt-2 flex items-center justify-between">
                <div class="flex items-center overflow-hidden rounded-full border border-gray-200">
                  <button type="button" class="qty-btn" data-local-qty="${item.id}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
                  <span class="w-8 text-center text-sm">${item.quantity}</span>
                  <button type="button" class="qty-btn" data-local-qty="${item.id}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
                </div>
                <span class="text-sm font-medium">${formatMoney(itemUnitCents(item) * Number(item.quantity || 1))}</span>
              </div>
            </div>
            <button type="button" class="self-start text-gray-400 hover:text-scotia" data-local-qty="${item.id}" data-qty="0" aria-label="Remove ${item.title}">×</button>
          </div>
        `;
      })
      .join("");

  const renderCart = async () => {
    let cart = { items: [], item_count: 0, total_price: 0 };
    try {
      cart = await fetch("/cart.js").then((r) => r.json());
    } catch {
      /* draft / local only */
    }
    setCartCount(cart.item_count);

    lastShopifyCart = cart;
    syncWhatsAppCheckoutLinks(cart);

    const itemsEls = qsa("[data-cart-items]");
    const emptyEls = qsa("[data-cart-empty]");
    const footerEls = qsa("[data-cart-footer]");
    const totalEls = qsa("[data-cart-total]");
    if (!itemsEls.length) return cart;

    const localItems = readLocal();
    const hasItems = (cart.items && cart.items.length) || localItems.length;
    const subtotal = Number(cart.total_price || 0) + localSubtotalCents();
    totalEls.forEach((el) => {
      el.textContent = formatMoney(subtotal);
    });

    if (!hasItems) {
      itemsEls.forEach((el) => {
        el.innerHTML = "";
      });
      emptyEls.forEach((el) => el.removeAttribute("hidden"));
      footerEls.forEach((el) => el.setAttribute("hidden", ""));
      return cart;
    }

    emptyEls.forEach((el) => el.setAttribute("hidden", ""));
    footerEls.forEach((el) => el.removeAttribute("hidden"));

    const shopifyRows = (cart.items || [])
      .map((item) => {
        const image = item.image
          ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, "&quot;")}" class="h-20 w-20 rounded-lg object-cover bg-scotia-grey" width="80" height="80">`
          : `<div class="h-20 w-20 rounded-lg bg-scotia-mist"></div>`;
        return `
          <div class="flex gap-3 border-b border-gray-100 py-4" data-key="${item.key}">
            ${image}
            <div class="min-w-0 flex-1">
              <p class="font-display text-sm font-semibold text-scotia">${item.product_title}</p>
              <p class="mt-1 text-xs text-gray-500">${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}</p>
              <div class="mt-2 flex items-center justify-between">
                <div class="flex items-center overflow-hidden rounded-full border border-gray-200">
                  <button type="button" class="qty-btn" data-qty-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
                  <span class="w-8 text-center text-sm">${item.quantity}</span>
                  <button type="button" class="qty-btn" data-qty-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
                </div>
                <span class="text-sm font-medium">${formatMoney(item.final_line_price)}</span>
              </div>
            </div>
            <button type="button" class="self-start text-gray-400 hover:text-scotia" data-qty-change="${item.key}" data-qty="0" aria-label="Remove ${item.product_title}">×</button>
          </div>
        `;
      })
      .join("");

    const rows = shopifyRows + renderLocalRows();
    itemsEls.forEach((el) => {
      el.innerHTML = rows;
    });
    return cart;
  };

  const addToCart = async (form) => {
    const body = new FormData(form);
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || "Unable to add to cart");
    }
    await renderCart();
    openCart();
  };

  const changeQty = async (key, qty) => {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(qty) }),
    });
    await renderCart();
  };

  const bindSearch = () => {
    const inputs = qsa("[data-predictive-search]");
    let timer;

    inputs.forEach((input) => {
      const root = input.closest("[data-search-root]") || document;
      const results = qs("[data-search-results]", root);

      input.addEventListener("input", () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 2) {
          if (results) results.innerHTML = "";
          return;
        }
        timer = setTimeout(async () => {
          const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
          const data = await fetch(url).then((r) => r.json()).catch(() => null);
          const products = data?.resources?.results?.products || [];
          const needle = q.toLowerCase();
          const localHits = (window.ScotiaCatalog || []).filter((item) =>
            `${item.title} ${item.strength}`.toLowerCase().includes(needle)
          ).slice(0, 8);
          if (!results) return;
          const shopifyRows = products.map(
            (p) => `
              <a href="${p.url}" class="flex items-center gap-3 px-4 py-3 hover:bg-scotia-grey">
                ${p.image ? `<img src="${p.image}" alt="" class="h-12 w-12 rounded object-cover">` : `<span class="h-12 w-12 rounded bg-scotia-mist"></span>`}
                <span>
                  <span class="block text-sm font-medium text-scotia">${p.title}</span>
                  <span class="text-xs text-gray-500">${p.price}</span>
                </span>
              </a>`
          );
          const localRows = localHits.map(
            (item) => `
              <a href="/collections/all#catalog-${item.id}" class="flex items-center gap-3 px-4 py-3 hover:bg-scotia-grey">
                ${item.image ? `<img src="${item.image}" alt="" class="h-12 w-12 rounded object-contain bg-white">` : `<span class="h-12 w-12 rounded bg-scotia-mist"></span>`}
                <span>
                  <span class="block text-sm font-medium text-scotia">${item.title} ${item.strength}</span>
                  <span class="text-xs text-gray-500">${item.price}</span>
                </span>
              </a>`
          );
          const rows = [...shopifyRows, ...localRows];
          if (!rows.length) {
            results.innerHTML = `<p class="p-4 text-sm text-gray-500">No products found for “${q}”.</p>`;
            return;
          }
          results.innerHTML = rows.join("");
        }, 180);
      });
    });
  };

  const bindTabs = () => {
    qsa("[data-tabs]").forEach((tabs) => {
      const buttons = qsa("[data-tab]", tabs);
      const panels = qsa("[data-tab-panel]", tabs);
      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const id = btn.getAttribute("data-tab");
          buttons.forEach((b) => b.setAttribute("aria-selected", b === btn ? "true" : "false"));
          panels.forEach((panel) => {
            panel.toggleAttribute("hidden", panel.getAttribute("data-tab-panel") !== id);
          });
        });
      });
    });
  };

  const bindPopup = () => {
    const popup = qs("[data-welcome-popup]");
    if (!popup) return;
    if (localStorage.getItem(POPUP_KEY) === "1") return;
    popup.removeAttribute("hidden");
    document.body.classList.add("popup-open");
    const confirm = qs("[data-welcome-confirm]", popup);
    const enter = qs("[data-welcome-enter]", popup);
    confirm?.addEventListener("change", () => {
      if (enter) enter.disabled = !confirm.checked;
    });
    enter?.addEventListener("click", () => {
      if (!confirm?.checked) return;
      localStorage.setItem(POPUP_KEY, "1");
      popup.setAttribute("hidden", "");
      document.body.classList.remove("popup-open");
    });
  };

  document.addEventListener("click", async (e) => {
    const openBtn = e.target.closest("[data-cart-open]");
    const closeBtn = e.target.closest("[data-cart-close]");
    const overlay = e.target.closest("[data-cart-overlay], [data-nav-overlay]");
    const navOpen = e.target.closest("[data-nav-open]");
    const navClose = e.target.closest("[data-nav-close]");
    const searchOpen = e.target.closest("[data-search-open]");
    const searchClose = e.target.closest("[data-search-close]");
    const qtyBtn = e.target.closest("[data-qty-change]");
    const localQty = e.target.closest("[data-local-qty]");
    const localAdd = e.target.closest("[data-local-cart]");
    const waCheckout = e.target.closest("[data-whatsapp-checkout]");
    const waProduct = e.target.closest("[data-whatsapp-product]");
    const checkoutLink = e.target.closest('a[href*="/checkout"], button[name="checkout"]');

    if (openBtn) {
      e.preventDefault();
      await renderCart();
      closeNav();
      closeSearch();
      openCart();
    }
    if (closeBtn || overlay) {
      closeCart();
      closeNav();
      closeSearch();
    }
    if (navOpen) {
      e.preventDefault();
      closeCart();
      document.body.classList.add("nav-open");
    }
    if (navClose) closeNav();
    if (searchOpen) {
      e.preventDefault();
      const panel = qs("[data-search-panel]");
      const isOpen = panel && !panel.hasAttribute("hidden");
      if (isOpen) {
        closeSearch();
      } else {
        panel?.removeAttribute("hidden");
        qs("[data-predictive-search]", panel)?.focus();
      }
    }
    if (searchClose) closeSearch();
    if (qtyBtn) {
      e.preventDefault();
      await changeQty(qtyBtn.getAttribute("data-qty-change"), qtyBtn.getAttribute("data-qty"));
    }
    if (localQty) {
      e.preventDefault();
      changeLocalQty(localQty.getAttribute("data-local-qty"), localQty.getAttribute("data-qty"));
      await renderCart();
    }
    if (localAdd) {
      e.preventDefault();
      addLocalItem({
        id: localAdd.getAttribute("data-id"),
        title: localAdd.getAttribute("data-title"),
        price: localAdd.getAttribute("data-price"),
        image: localAdd.getAttribute("data-image"),
        cents: priceToCents(localAdd.getAttribute("data-price"), localAdd.getAttribute("data-cents")),
      });
      await renderCart();
      openCart();
    }
    if (waProduct) {
      e.preventDefault();
      const title = waProduct.getAttribute("data-title") || "research peptides";
      const price = waProduct.getAttribute("data-price") || "";
      const cents = priceToCents(price, waProduct.getAttribute("data-cents"));
      const total = cents ? formatPounds(cents) : price;
      goToWhatsApp(
        waLink(
          [
            "Hi Scotia Peptides, I would like to order:",
            "",
            `• 1x ${title}${price ? ` (${price})` : ""}`,
            "",
            total ? `Total: ${total}` : ""
          ]
            .filter(Boolean)
            .join("\n")
        )
      );
    }
    if (waCheckout || checkoutLink) {
      e.preventDefault();
      openWhatsAppOrder();
    }
  });

  document.addEventListener("submit", async (e) => {
    if (e.submitter && e.submitter.getAttribute("name") === "checkout") {
      e.preventDefault();
      openWhatsAppOrder();
      return;
    }

    const formEl = e.target.closest("form");
    const contactForm = formEl && formEl.querySelector('[name="contact[body]"]') ? formEl : null;
    if (contactForm && contactForm.dataset.gmailSent !== "1") {
      e.preventDefault();
      const fd = new FormData(contactForm);
      const email = window.ScotiaTheme?.contactEmail || "scotiapeptides@gmail.com";
      try {
        await fetch(`https://formsubmit.co/ajax/${encodeURIComponent(email)}`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            name: fd.get("contact[name]") || "",
            email: fd.get("contact[email]") || "",
            message: fd.get("contact[body]") || "",
            page: window.location.href,
            _subject: "Scotia Peptides website enquiry",
          }),
        });
      } catch {
        /* Shopify still receives the form below */
      }
      contactForm.dataset.gmailSent = "1";
      contactForm.submit();
      return;
    }

    const form = e.target.closest("form[data-ajax-cart]");
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector("[type='submit']");
    const original = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Adding…";
    }
    try {
      await addToCart(form);
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = original;
      }
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeCart();
      closeNav();
      closeSearch();
    }
  });

  qsa("[data-qty-input-wrap]").forEach((wrap) => {
    wrap.addEventListener("click", (e) => {
      const input = qs("input[name='quantity']", wrap);
      if (!input) return;
      if (e.target.closest("[data-qty-minus]")) input.value = Math.max(1, Number(input.value) - 1);
      if (e.target.closest("[data-qty-plus]")) input.value = Number(input.value) + 1;
    });
  });

  const scrollToHash = () => {
    const hash = window.location.hash;
    if (!hash || !/^#(cat|catalog)-/.test(hash)) return;
    const el = document.getElementById(hash.slice(1));
    if (!el) return;
    const header = document.querySelector("header");
    const offset = (header ? header.getBoundingClientRect().height : 80) + 16;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  };

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href*="#cat-"], a[href*="#catalog-"]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.pathname.replace(/\/$/, "") !== window.location.pathname.replace(/\/$/, "")) return;
    if (!document.getElementById(url.hash.slice(1))) return;
    e.preventDefault();
    history.pushState(null, "", url.hash);
    window.requestAnimationFrame(scrollToHash);
  });

  window.addEventListener("hashchange", scrollToHash);
  window.setTimeout(scrollToHash, 250);
  window.setTimeout(scrollToHash, 900);

  bindSearch();
  bindTabs();
  bindPopup();
  renderCart().catch(() => setCartCount(0));

  const revealEls = qsa("[data-reveal]");
  const showReveal = (el) => {
    window.requestAnimationFrame(() => el.classList.add("is-visible"));
  };
  if (!("IntersectionObserver" in window)) {
    revealEls.forEach(showReveal);
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          showReveal(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.01, rootMargin: "80px 0px 80px 0px" }
    );
    revealEls.forEach((el) => io.observe(el));
    window.setTimeout(() => revealEls.forEach(showReveal), 900);
  }
})();
